import React from 'react';
import './App.scss';
import { MailStatus } from './components/MailStatus';

function App() {
    return (
        <div className="App">
            <h1>{window.wpMailManagerI18n.settingsHeaderH1}</h1>
            <MailStatus />
        </div>
    );
}

export default App;
